import angular from "angular";
import { RecordGridController } from "./controller";

export const vsName = "recordGrid";
export * from "./recordDataSource";

const recordGridTemplateHtml: string =
  require("!html-loader!./index.html").default;

export const recordGridComponentOptions: angular.IComponentOptions = {
  controller: RecordGridController,
  controllerAs: "recordGridController",
  bindings: {
    columns: "<",
    datasource: "<",
    gridSettings: "<",
    defaultQuery: "<?",
    defaultSort: "<?",
    gridSelectionChanged: "&?",
    onItemCommand: "&?",
    initialSelectedIds: "<?",
    showSelectButtons: "<?",
    showDownloadButton: "<?",
  },
  template: recordGridTemplateHtml,
  transclude: {
    gridHeader: "?gridHeader",
  },
};
